module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.permissions.includes("canTriggerAdProposalReviewNotification")) ? _c('trigger-notification', {
    staticClass: "mt-2 mb-4",
    attrs: {
      "kind": "creative",
      "modelKey": _vm.creative.id,
      "notification": _vm.NOTIFICATION_EVENTS.CREATIVITY_AD_PROPOSAL_REVIEW
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.trigger-ad-review-notification')))]) : _vm._e(), (_vm.permissions.includes("canTriggerWeAreSettingYouLiveNotification")) ? _c('trigger-notification', {
    staticClass: "mt-2 ml-1 mb-4",
    attrs: {
      "kind": "creative",
      "modelKey": _vm.creative.id,
      "notification": _vm.NOTIFICATION_EVENTS.CREATIVITY_WE_ARE_SETTING_YOU_LIVE
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.trigger-we-are-setting-you-live-notification')))]) : _vm._e(), (_vm.permissions.includes("canTriggerOnboardingWarningNotification")) ? _c('trigger-notification', {
    staticClass: "ml-1 mb-4",
    attrs: {
      "kind": "creative",
      "modelKey": _vm.creative.id,
      "notification": _vm.NOTIFICATION_EVENTS.ONBOARDING_WARNING
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.trigger-onboarding-warning-notification')))]) : _vm._e()], 1), (_vm.permissions.includes("canMoveFromHold")) ? _c('div', {
    staticClass: "col-12 mb-3 text-right"
  }, [_c('gotu-nav-button', {
    staticClass: "save-btn ml-1",
    attrs: {
      "theme": "default-filter",
      "loading": _vm.moving,
      "disabled": _vm.moving
    },
    on: {
      "click": _vm.onMoveForward
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.move-from-hold')))])], 1) : _vm._e(), (_vm.campaign) ? _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('box-widget', {
    staticClass: "back-to"
  }, [_c('template', {
    slot: "content"
  }, [_c('b-btn', {
    attrs: {
      "variant": "link",
      "to": {
        name: "campaign",
        params: {
          code: _vm.campaign.code
        }
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "angle-left",
      "scale": 2
    }
  }), _vm._v(_vm._s(_vm.$t('pos.creative.back-to-campaign')))], 1)], 1)], 2)], 1) : _vm._e(), _c('div', {
    staticClass: "col-12 mb-3"
  }, [_c('campaign-notification', {
    staticClass: "mb-3",
    attrs: {
      "icon": _vm.notificationBox.icon,
      "title": _vm.$t(_vm.notificationBox.text, {
        "reason": _vm.reasons
      })
    }
  })], 1), (_vm.showExternalPreviews) ? _c('div', {
    staticClass: "col-12"
  }, [_c('file-gallery', {
    attrs: {
      "files": _vm.getCreativeExternalPreviews
    }
  }), (_vm.canUpdateBriefStatus) ? _c('creative-preview-feedback', {
    attrs: {
      "creative": _vm.creative,
      "permissions": _vm.permissions
    },
    on: {
      "approveCreative": function($event) {
        _vm.finish(false)
      }
    }
  }) : _vm._e()], 1) : (_vm.showPreview) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('creative-preview-wrapper', {
    attrs: {
      "creative": _vm.creative,
      "facebookPage": _vm.creative.campaign.fbpage,
      "landingPage": _vm.facebookPage,
      "enableFormPreview": true
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "col-12 mt-2"
  }, [(_vm.isInApproved) ? _c('p', {
    staticClass: "approvedComment"
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.approvedMsg')))]) : _vm._e(), (_vm.permissions.includes("addComment")) ? _c('b-collapse', {
    attrs: {
      "id": "commentCollapse",
      "visible": _vm.isCommentBlockVisible && !(_vm.commentTypes.REJECT in _vm.commentType)
    }
  }, [(!_vm.isInApproved && !_vm.isInHold) ? _c('comment', {
    ref: "comment",
    attrs: {
      "label": _vm.$t("pos.creative.your-campaign-brief"),
      "placeholder": _vm.$t("pos.creative.your-campaign-brief-description"),
      "comment": _vm.comment
    }
  }, [_c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [(_vm.commentTypes.UPDATE in _vm.commentType) ? _c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "disabled": _vm.updatingComment,
      "loading": _vm.loadingUpdatingComment,
      "data-test": "update-comment"
    },
    on: {
      "click": function($event) {
        _vm.processComment(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.comment.update-comment')))]) : _vm._e(), _c('span', [_vm._v(" ")]), (_vm.permissions.includes("moveForward")) ? _c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "disabled": _vm.updatingComment,
      "loading": _vm.loadingAddingComment,
      "data-test": "save-comment"
    },
    on: {
      "click": function($event) {
        _vm.processComment(false)
      }
    }
  }, [(_vm.commentTypes.UPDATE in _vm.commentType) ? [_vm._v(_vm._s(_vm.$t('pos.creative.save-and-confirm')))] : (_vm.commentTypes.REJECT in _vm.commentType) ? [_vm._v(_vm._s(_vm.$t('pos.creative.reject')))] : [_vm._v(_vm._s(_vm.$t('pos.comment.add-comment')))]], 2) : _vm._e()], 1)]) : _vm._e()], 1) : _vm._e()], 1), (_vm.canViewTimeline) ? _c('div', {
    staticClass: "col-12"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('pos.timeline.title.creative')))]), _c('hr'), _c('timeline', {
    attrs: {
      "items": _vm.timelineItems
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ebfadaf"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/creative-step/CreativeStep.vue
// module id = 2072
// module chunks = 1